"use client";

import * as React from "react";

import { cn } from "@/lib/utils";

import { Button } from "@/components/ui/button";

interface GlassButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  asChild?: boolean;
}

function GlassButton({
  children,
  asChild,
  className,
  ...props
}: GlassButtonProps) {
  return (
    <Button
      asChild={asChild}
      className={cn(
        "relative inline-flex h-10 shrink-0 rounded-xl bg-transparent! bg-clip-padding px-6 text-base text-[var(--glass-text)]! transition-opacity duration-200 hover:opacity-80 active:translate-y-0",

        "bg-[linear-gradient(to_left,var(--glass-panel-from),var(--glass-panel-to))] backdrop-blur-xs",

        "before:pointer-events-none before:absolute before:inset-0 before:size-full before:rounded-[inherit] before:border before:border-transparent before:bg-origin-border",

        "before:bg-[conic-gradient(from_var(--button-angle)_at_50%_50%,var(--glass-highlight),var(--glass-highlight-transparent)_10%_43%,var(--glass-highlight)_50%,var(--glass-highlight-transparent)_73%_93%,var(--glass-highlight))]",

        "before:mask-[linear-gradient(#fff_0_0),linear-gradient(#fff_0_0)] before:mask-exclude before:[mask-clip:content-box,border-box]",

        "before:transition-[--button-angle] before:duration-500 before:ease-in-out hover:before:[--button-angle:-125deg]",

        className,
      )}
      {...props}
    >
      {children}
    </Button>
  );
}

export { GlassButton, type GlassButtonProps };
